import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-toolbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-toolbar.component.html',
  styleUrls: ['./list-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListToolbarComponent {
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 9;
  @Input() viewMode: 'grid' | 'list' = 'grid';
  @Input() currentSort = 'newest';
  @Input() sortOptions: { label: string; value: string }[] = [
    { label: 'Newest Arrivals', value: 'newest' },
    { label: 'Price: Low to High', value: 'price_asc' },
    { label: 'Price: High to Low', value: 'price_desc' },
  ];

  @Output() viewChange = new EventEmitter<'grid' | 'list'>();
  @Output() sortChange = new EventEmitter<string>();
  @Output() filterToggle = new EventEmitter<void>();

  get start(): number {
    if (this.total === 0) return 0;
    return (this.page - 1) * this.pageSize + 1;
  }

  get end(): number {
    return Math.min(this.page * this.pageSize, this.total);
  }

  onViewChange(mode: 'grid' | 'list') {
    this.viewChange.emit(mode);
  }

  onSortChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.sortChange.emit(value);
  }

  onFilterToggle() {
    this.filterToggle.emit();
  }
}
